// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;But I am like one who is deaf and hears not,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;like one that is dumb, who does not open his mouth.<br> </p> </div></div>";
// Exports
module.exports = code;